// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://js.arcgis.com/4.18/esri/css/main.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* import the required JSAPI css */
.esri-view {
  height: 500px;
}

.center {
  position: relative;
  bottom: 55px;
  left: 10px;
  width: 35px;
}

.center ::ng-deep .mat-mdc-progress-spinner circle, .mat-mdc-progress-spinner circle {
  stroke: #000000;
  position: relative;
  bottom: 60px;
  left: 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
